import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent implements OnInit {

  constructor(private modal: ModalService) { }

  @Input()
  public title: string = 'Text Editor'

  @Input()
  public text: string = '';

  @Output()
  public commit = new EventEmitter<string>();

  ngOnInit(): void {
  }

  public close() {
    this.modal.of(this).hide();
  }

  public save() {
    this.modal.of(this).hide();
    this.commit.emit(this.text);
  }
}
